import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { PermitActions, PermitSelectors } from '@ruby/modules/unit-train/store/permit.index';

@Component({
  selector: 'ng-permit-single-container',
  templateUrl: './permit-single.container.html',
  styleUrls: ['./permit-single.container.scss']
})
export class PermitSingleContainer {
  store$: Observable<{ selectedPermit?: string; permits: Array<{ name: string; title?: string; permitType?: string }> }>;

  constructor(private store: Store) {
    this.store$ = store.select(PermitSelectors.selectPermits);
  }

  /**
   * Add Permit
   *
   * @summary emit an event to update the state to add a permit
   * @return void
   */
  addPermitTab(): void {
    this.store.dispatch(PermitActions.addPermit());
  }

  /**
   * Remove Permit
   *
   * @summary emit an event to update the state to remove a permit
   * @param $permitName: string
   * @return void
   */
  removePermitTab($permitName: string): void {
    this.store.dispatch(PermitActions.removePermit({ data: $permitName }));
  }
}
